module.exports = __webpack_public_path__ + "9a1c5f773c4b6c982a2bec784b505d14.svg";